import styled from 'styled-components'

export const IconWrapper = styled.div`
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
`
